<template>
  <a
    class="bg-white shadow hover:shadow-md flex flex-col justify-between text-center no-underline rounded mx-2 h-card"
    :id="'location-' + location.id"
    :href="'/explore/' + location.id + '/' + location.slug">
    <h4 class="leading-loose font-medium text-sm bg-brick rounded-t p-name" v-bind:class="sponsored">{{ location.name }} <sponsor class="h-6 float-right p-1" v-show="location.sponsor"></sponsor></h4>
    <div class="flex-1 leading-loose text-sm py-6 text-charcoal">
      <p :class="location.phone ? 'mb-0' : 'mb-7'">{{ location.address_street }}<span v-show="location.address_number">, {{ location.address_number }}</span></p>
      <p v-show="location.phone">{{ location.phone }}</p>
    </div>
    <div class="flex mt-1">
      <link-card
        title="Go to Facebook Page"
        :url="location.facebook ? 'https://facebook.com/' + location.facebook : ''"
        icon="facebook"
        :sponsor="location.sponsor"
        class-override="rounded-bl">
      </link-card>
      <link-card
        title="Go to Twitter"
        :url="location.twitter ? 'https://twitter.com/' + location.twitter : ''"
        icon="twitter"
        :sponsor="location.sponsor">
      </link-card>
      <link-card
        title="Go to Instagram"
        :url="location.instagram ? 'https://instagram.com/' + location.instagram : ''"
        icon="instagram"
        :sponsor="location.sponsor">
      </link-card>
      <link-card
        title="Go to Yelp Listing"
        :url="location.yelp ? 'https://yelp.com/' + location.yelp : ''"
        icon="yelp"
        :sponsor="location.sponsor">
      </link-card>
      <a href="#" title="View on Map" v-on:click="selectLocation" class="flex-1 p-2" :class="location.sponsor ? 'bg-brick-lighter hover:bg-brick text-brick hover:text-brick-lightest' : 'bg-gold-lighter hover:bg-gold text-gold hover:text-gold-lighter'">
        <mapIcon classes="fill-current w-4 h-4 block mx-auto"></mapIcon>
      </a>
      <link-card title="Go to Website" :url="location.url" icon="globe" :sponsor="location.sponsor" class-override="rounded-br u-url"></link-card>
    </div>
  </a>
</template>

<script>
  import VueScrollTo from 'vue-scrollto'
  import sponsor from './Sponsor'
  import linkCard from './LinkCard'
  import mapIcon from './MapIcon'

  export default {
    props: ['location'],
    components: {
      sponsor,
      linkCard,
      mapIcon
  },
    created() {
      // let self = this
      // window.events.$on('scrollLocation', clickedLocation => {
      //   console.log('map');

      //   VueScrollTo.scrollTo('#map')
      //   // if (clickedLocation == self.location.id) {
      //   //   VueScrollTo.scrollTo('#location-' + clickedLocation)
      //   // }
      // })
    },
    computed: {
      sponsored() {
        return this.location.sponsor ? 'bg-brick text-brick-lightest' : 'bg-gold text-white'
      }
    },
    methods: {
      selectLocation(e) {
        // if (!this.location.sponsor) {
          e.preventDefault()
          VueScrollTo.scrollTo('#map')
          window.events.$emit('selectLocation', this.location)
        // }
      }
    }
  }
</script>
